<template>
    <a-layout-content class="p-all">
        <a-row :gutter="{xs:0, lg:8}">
            <a-col :xs="24" :lg="8">
                <a-card>
                    <span class="m-text-title" slot="title">Filter</span>
                    <div class="d-flex flex-column">
                        <a-input-search v-model="search" placeholder="Pencarian ... " />
                        <a-collapse activeKey="1" class="m-top">
                        <a-collapse-panel key="1">
                            <span slot="header">Cari Lebih Lengkap</span>
                            <div class="m-form-item-wrapper">
                            <label for="tanggalTransaksi">Tanggal Transaksi</label>
                            <a-date-picker
                                v-model="transactionDt"
                                @change="searching"
                                :format="getDefaultDateFormat"
                                allowClear
                            />
                            </div>
                            <div class="m-form-item-wrapper">
                            <label for="tanggalTransaksi">Status</label>
                            <a-select
                                placeholder="Ex: Approved ... "
                                v-model="status"
                                @change="searching"
                                class="w-full"
                                initialValue="delivered"
                                allowClear
                            >
                                <a-select-option value="delivered">Delivered</a-select-option>
                                <a-select-option value="approved">Approved</a-select-option>
                                <a-select-option value="on process">On Process</a-select-option>
                                <a-select-option value="revised">Revised</a-select-option>
                                <a-select-option value="rejected">Rejected</a-select-option>
                            </a-select>
                            </div>
                        </a-collapse-panel>
                        </a-collapse>
                    </div>
                </a-card>
            </a-col>

            <a-col :xs="24" :lg="16">
                <H-List
                title="Daftar Permohonan Klaim"
                createLink="createKlaim"
                manifestLink="manifestKlaim"
                editLink="edit"
                :dataList="dataConstruct"
                :isLoading="loading"
                >
                <template #title-right="{ item }">
                    <a-tag :color="handleColor(item.is_rekap)">{{ handleTag(item) }}</a-tag>
                </template>
                <div slot="action-button">
                    <a-button type="primary" @click="handleCreate('Create')">
                    <a-icon type="plus" />
                    &nbsp;{{isMobile ? '' : 'Create klaim'}}
                    </a-button>
                </div>
                <template slot="change-button" slot-scope="{item}">
                    <a-button type="danger" @click="handleRevise(item)">
                    <a-icon type="edit" />&nbsp; Ubah Data
                    </a-button>
                </template>
                </H-List>
            </a-col>

        </a-row>

    </a-layout-content>
</template>

<script>
import { mapGetters } from "vuex";
import DataList from "@/components/Datalist";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default{
    mixins: [CurrencyFormat],
    components: {
        "H-List": DataList
    },
    data(){
        return {
            moment,
            transactionDt: null,
            search: "",
            status: "",
            loading: {
                list: false
            },
            tlc: '',
            list_data: [],
            raw_data: [],
            loading: false
        }
    },

    computed: {
        ...mapGetters([
            "getAuth",
            "getCuti",
            "getDefaultDateFormat",
            "getStandartFormatDate"
        ]),

        dataConstruct(){
            let output = [];
            this.list_data.forEach(d => {
                output.push({
                    title: d.no_klaim,
                    subdesc: [
                        [
                            { label: "Tanggal Transaksi ", value: moment(d.create_dt).format("YYYY-MM-DD") },
                            { label: "Total Klaim ", value: this.formatRupiah(d.total_klaim) },
                            { label: "Pembuat ", value: d.tlc_create },
                        ]
                    ],
                    description: "",
                    status: d.status,
                    timeline: [
                        {
                            status: d.status,
                            actor: d.actor
                        }
                    ],
                    id: d.id_klaim_kesehatan_hdr,
                    is_rekap: d.is_rekap
                });
            });

            return output
        },

        searching(){
            this.list_data = this.raw_data

            if(this.search){
                this.list_data = this.list_data.filter((d) => 
                    d.no_klaim.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || 
                    d.create_dt.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                    d.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                    d.status.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || 
                    d.total_klaim.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
                )
            }

            if(this.transactionDt){
                let searchDate = moment(this.transactionDt).format(
                    this.getStandartFormatDate
                )
                this.list_data = this.list_data.filter((d) => 
                    moment(d.create_dt).format("YYYY-MM-DD") === searchDate
                )
            }

            if(this.status){
                this.list_data = this.list_data.filter((d) => 
                    d.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
                )
            }
        }
    },

    watch: {
        $route(to, from) {
            if(to.name == 'listKlaim'){
                this.fetchData()
            }
        }
    },

    mounted(){
        this.fetchData()
    },

    methods: {
        async fetchData(){
            this.loading = true
            const payload = {
                tlc: this.getAuth.username
            }

            try {
                const response = await this.asyncAxiosGet("klaim_kesehatan/list", this.getAuth, payload);
                this.list_data = response.data
                this.raw_data = response.data
                this.loading = false
            } catch (error) {
                console.log(error);
                this.loading = false
            }
        },

        handleCreate(params){
            this.$router.push({ name: "createKlaim" });
        },

        handleRevise(params){
          this.$router.push({
            name: "reviseKlaim",
            params: { id: params.id},
          });
        },

        handleTag(item){
            if(item.is_rekap) return 'Has Been Transferred'
            else return 'Not Yet Transferred'
        },

        handleColor(val){
            if(val) return 'grey'
            else return ''
        }
    }
}
</script>